import React from 'react';

const Modal = ({ onClose, children, maxWidthClass = 'max-w-md' }) => {
  return (
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center bg-forest-deepest/50 p-4 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className={`max-h-[calc(100dvh-2rem)] w-full overflow-y-auto ${maxWidthClass} rounded-none border border-forest/10 bg-canvas p-7 shadow-elevation-md`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;
